import React from "react";
import CardView from "../shared/card-view/CardView";
import WordListStates, { WordListProps, WordView } from "./WordList.models";
import './WordList.scss';
import imageSource from '../../assest/images/leitner/wordListIcon3.png';
import FlashCardService from "../../services/content/FlashCardService";

export default class WordList extends React.PureComponent<WordListProps, WordListStates>{

    flashCardService: FlashCardService;
    constructor(props: WordListProps) {
        super(props);
        this.flashCardService = new FlashCardService();

        this.state = { boxId: '', wordView: [] }
    }


    componentDidMount = () => {
        if (this.props.boxId !== null && this.props.boxId !== undefined) {
            this.setState({ boxId: this.props.boxId });
            this.getPaged();
        }
    }

    componentDidUpdate = (prevProps: WordListProps) => {
        if (prevProps.boxId !== this.props.boxId && this.props.boxId !== null && this.props.boxId !== undefined) {
            this.setState({ boxId: this.props.boxId });
            this.getPaged();
        }
    }

    getPaged = () => {
        let state = this;
        this.flashCardService.getPaged(this.props.boxId as string, { pageSkip: 0, pageSize: 0, orderField: "ID", descendingOrder: true }).then(response => {
            var count = response.totalRowCount;

            var fixCount = Math.ceil(count / 50);
            var result: WordView[] = [];
            for (var i = 1; i <= fixCount; i++) {
                var first = i === 1 ? 1 : (i * 50) + 1;
                var last = 50 * i;
                result.push({ title: `${first} تا ${last}`, skip: i - 1 })
            }

            state.setState({ wordView: result })
        })
    }


    render(): React.ReactNode {
        let { wordView } = this.state;
        return <>
            <div className="dropdown-list word-book-marked-list" >
                <div className="row">
                    <div className="col-6">
                        {wordView.map((word, key) => {
                            return <CardView key={key} config={{ buttonText: 'مشاهده', showButton: true, imageSource: imageSource, title: word.title, redirector: `/LeitnerWordView?boxId=${this.state.boxId}&skip=${word.skip}` }} />;
                        })}
                    </div>
                </div>
            </div>
        </>
    }
}